import { useEffect } from "react";
import { reCaptchaUrl } from "../../auth/general/ReCaptcha/constants";
import { PureVoidFunc } from "../../helpers/functions/types";

export const useScript = (
  url: string,
  type: string = "",
  noModule: boolean = false,
  onError?: PureVoidFunc,
) => {
  useEffect(() => {
    const scriptElements = document.getElementsByTagName("script");
    for (let i = 0; i < scriptElements.length; i++) {
      if (scriptElements[i].src === url) {
        return;
      }
    }

    const script = document.createElement("script");

    script.src = url;
    script.async = true;
    script.defer = true;
    script.type = type;
    script.noModule = noModule;
    script.onerror = () => {
      onError && onError();
    };

    document.body.appendChild(script);

    return () => {
      const currentParent = script.parentNode;
      if (currentParent) {
        currentParent.removeChild(script);
      } else
        console.error(
          `script parent not found for ${url === reCaptchaUrl ? "Google Recaptcha" : "vviinn widget"}`,
        );
    };
  }, [url, onError]);
};
